import { AlertTriangle } from 'lucide-react'
import { useActionCable } from '@/common/hooks/cable/useActionCable'
import { ChannelStatus } from '@/common/types/cable/actionCable.type'
import { AUCTION_BIDDING_CHANNEL } from '../../constants/auctionChannel.constant'
import { useAuctionUpdatedSummary } from '../../hooks/useAuctionUpdatedSummary'
import { AuctionSummaryTransformer } from '../../services/auctionSummaryTransformer'
import { AuctionCardData } from '../../types/auctionCard.type'
import AuctionCard from '../AuctionCard'

type Props = {
  data: AuctionCardData
}

const AuctionFollowingCard = ({ data }: Props) => {
  const { data: summary, refetch } = useAuctionUpdatedSummary({ id: data.id })

  const { status } = useActionCable({
    channel: AUCTION_BIDDING_CHANNEL,
    params: { auction_entry_id: data.id },
    enabled: !!data.id,
    onMessage: () => {
      refetch()
    },
  })

  const realtimeRejected = status === ChannelStatus.Rejected

  const card: AuctionCardData = summary
    ? { ...AuctionSummaryTransformer.mapAuctionSummaryToCard('in_dispute')(summary), companyName: data.companyName, original: data.original }
    : data

  return (
    <div className="flex flex-col gap-1 shrink-0">
      {realtimeRejected && (
        <div className="flex items-center gap-1 rounded-md bg-danger-soft/15 px-2 py-1 text-[10px] font-semibold text-danger-soft">
          <AlertTriangle size={12} strokeWidth={1.75} />
          Sem permissão para a atualização em tempo real
        </div>
      )}

      <AuctionCard data={card} />
    </div>
  )
}

export default AuctionFollowingCard
